import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "@store/middleware";

import { getApplicationSpaBackendUrl } from "@utils";
import { type IDocumentWithInfo } from "@types";

export const USER_DOCUMENTS_API_REDUCER_KEY = "userDocumentsApi";
export const userDocumentsApi = createApi({
  reducerPath: USER_DOCUMENTS_API_REDUCER_KEY,
  baseQuery: (arguments_, api, extraOptions) =>
    baseQueryWithAuth({ baseUrl: getApplicationSpaBackendUrl() })(arguments_, api, {
      ...extraOptions,
      isExternalService: true,
    }),
  tagTypes: ["USER_DOCUMENTS"],
  endpoints: (builder) => ({
    getUserDocuments: builder.query<IDocumentWithInfo[], void>({
      query: () => ({
        url: "/documents",
        method: "GET",
      }),
      providesTags: ["USER_DOCUMENTS"],
    }),
  }),
});

export const { useGetUserDocumentsQuery, useLazyGetUserDocumentsQuery } = userDocumentsApi;
